// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
export var p500 = `#ffed00`;
export var p600 = `#e9d800`;
export var s000 = `#ffffff`;
export var s100 = `#f9f9f9`;
export var s200 = `#ededed`;
export var s300 = `#dadada`;
export var s400 = `#c7c7c7`;
export var s500 = `#9d9d9d`;
export var s600 = `#6f6f6f`;
export var s700 = `#3c3c3c`;
export var s800 = `#252525`;
export var s900 = `#000000`;
export var red = `#e60046`;
export var orange = `#ffa700`;
export var green = `#00aa46`;
export var ab10 = `rgba(0, 0, 0, 0.1)`;
export var ab20 = `rgba(0, 0, 0, 0.2)`;
export var ab30 = `rgba(0, 0, 0, 0.3)`;
export var ab40 = `rgba(0, 0, 0, 0.4)`;
export var ab50 = `rgba(0, 0, 0, 0.5)`;
export var aw10 = `rgba(255, 255, 255, 0.1)`;
export var aw20 = `rgba(255, 255, 255, 0.2)`;
var _1 = `#f06ea5`;
export { _1 as "heather-violet" };
export var magenta = `#e6007d`;
export var purple = `#89297d`;
export var lilac = `#462882`;
var _2 = `#0069be`;
export { _2 as "signal-blue" };
var _3 = `#00a0e6`;
export { _3 as "light-blue" };
export var turquoise = `#008796`;
export var teal = `#00b9be`;
export var brown = `#af5623`;
export var white = `#ffffff`;
export var black = `#000000`;
export var text = `#6f6f6f`;
export var error = `#e60046`;
export var divider = `#dadada`;
export var incomplete = `#9d9d9d`;
var _4 = `#fcd9e3`;
export { _4 as "error-bg" };
var _5 = `#d9f2e3`;
export { _5 as "success-bg" };
var _6 = `#fff4d9`;
export { _6 as "warning-bg" };
var _7 = `#f5f5f5`;
export { _7 as "info-bg" };
export var blue = `#0a75c3`;
export var score0 = `#440154`;
export var score10 = `#8B3899`;
export var score20 = `#AB55D4`;
export var score30 = `#503CCE`;
export var score40 = `#232E8E`;
export var score50 = `#30688E`;
export var score60 = `#2AB07F`;
export var score70 = `#66CC5D`;
export var score80 = `#BCDF27`;
export var score90 = `#FFED00`;
export var insightValue0 = `#440154`;
export var insightValue1 = `#8b3899`;
export var insightValue2 = `#ac55d4`;
export var insightValue3 = `#503cce`;
export var insightValue4 = `#232e8e`;
export var insightValue5 = `#30688e`;
export var insightValue6 = `#2ab07f`;
export var insightValue7 = `#66cc5d`;
export var insightValue8 = `#bcdf27`;
export var insightValue9 = `#ffed00`;
export default ___CSS_LOADER_EXPORT___;
